export { default } from './LeftPanelReferralBanner';
